/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioWaveIcon64Regular = forwardRef('MediaAudioWaveIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M28 10.5a1.5 1.5 0 0 0-3 0v43a1.5 1.5 0 0 0 3 0v-43Z" }),
        React.createElement("path", { d: "M48 17.5a1.5 1.5 0 0 0-3 0v29a1.5 1.5 0 1 0 3 0v-29Z" }),
        React.createElement("path", { d: "M58 26.5a1.5 1.5 0 0 0-3 0v11a1.5 1.5 0 1 0 3 0v-11Z" }),
        React.createElement("path", { d: "M36.5 22a1.5 1.5 0 0 1 1.5 1.5v17a1.5 1.5 0 1 1-3 0v-17a1.5 1.5 0 0 1 1.5-1.5Z" }),
        React.createElement("path", { d: "M16.5 18a1.5 1.5 0 0 1 1.5 1.5v25a1.5 1.5 0 1 1-3 0v-25a1.5 1.5 0 0 1 1.5-1.5Z" }),
        React.createElement("path", { d: "M8 27.5a1.5 1.5 0 0 0-3 0v9a1.5 1.5 0 1 0 3 0v-9Z" })));
});
